import * as Sentry from "@sentry/react";
import { useEffect } from "react";

import { useGetMe } from "@/services/api-hooks/user";

export const SentryUserContext = () => {
  const { data: user } = useGetMe();

  useEffect(() => {
    if (user) {
      Sentry.setUser({
        id: user.user_id,
        email: user.email,
        username: user.name,
      });
    } else {
      Sentry.setUser(null);
    }
  }, [user]);

  return null;
};
